import React from 'react';
import classNames from 'classnames';
import type { ErrorBoundaryType } from '../components/ErrorBoundary';
import styles from './RootErrorBoundaryFallback.module.scss';
import SlabLogo from '../components/SlabLogo';
import Link from '../utils/router/Link';

const MESSAGES: Record<
  ErrorBoundaryType,
  { title: string; description: string }
> = {
  translation: {
    title: 'Oops! Translation tool may have errored',
    description:
      'We encountered an unresolvable error typically caused by translation tools. Please disable any and reload the page, or contact our support for additional help.',
  },
  unsupportedBrowser: {
    title: 'Oops! Unsupported browser error',
    description:
      'We encountered an unresolvable error typically caused by outdated or unsupported browsers. Please update or try a different one, or contact our support for additional help.',
  },
  unknown: {
    title: 'Oops! Something went wrong',
    description:
      'We encountered an unresolvable error and have logged it for investigation. Please go back to the home page or contact our support if the issue persists.',
  },
};

interface RootErrorBoundaryFallbackProps {
  type: ErrorBoundaryType;
}

const RootErrorBoundaryFallback = ({
  type,
}: RootErrorBoundaryFallbackProps) => (
  <div className={styles.container}>
    <div className={styles.background} />
    <div className={styles.content}>
      <div className={styles.logo}>
        <SlabLogo />
      </div>
      <h2>{MESSAGES[type].title}</h2>
      <div className={styles.description}>{MESSAGES[type].description}</div>
      <div className={styles.actions}>
        <Link className={styles.button} to="mailto:support@slab.com">
          Email support
        </Link>
        <Link className={classNames(styles.button, styles.primary)} to="/">
          Go back to home
        </Link>
      </div>
    </div>
  </div>
);

export default RootErrorBoundaryFallback;
